<template>
  <div class="row gx-3 gy-1 gy-lg-2">
    <div class="col-12 col-md-8">
      <div class="row row-cols-1 gx-3 gy-1">
        <div class="col">
          <div class="card mb-3">
            <h5 class="card-header bg-secondary">製品検査資料</h5>
            <div class="card-body">
              <div class="row row-cols-1 row-cols-md-2 g-1">
                <div
                  v-for="inspection_type in inspection_types"
                  :key="inspection_type.id"
                  class="col"
                >
                  <button
                    @click="goToList(inspection_type)"
                    class="btn btn-lg btn-outline-secondary w-100 py-3"
                  >
                    {{ inspection_type.name }}
                  </button>
                </div>
                <div class="col">
                  <button
                    @click="showTypeCreateForm"
                    class="btn btn-lg btn-secondary w-100 py-3"
                  >
                    ＋工程追加
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card border-dark mb-3">
        <div class="card-body">
          <div class="row row-cols-1 g-1">
            <div class="col">
              <router-link
                :to="{
                  name: 'ManageInspectionPlan',
                }"
                class="btn btn-lg btn-secondary w-100 py-3"
                >検査指示</router-link
              >
            </div>
            <div class="col">
              <router-link
                :to="{
                  name: 'UserList',
                }"
                class="btn btn-lg btn-outline-dark w-100 py-3"
                >ユーザー</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <InspectionTypeCreateForm ref="typeCreateForm" @insert-type="insertType" />
</template>

<script>
import inspectionStore from '@/apps/inspection/manage/store'
import InspectionTypeCreateForm from '../components/InspectionTypeCreateForm.vue'
import store from '../store'

export default {
  name: 'MenuInspectionMonitor',
  components: {
    InspectionTypeCreateForm,
  },

  computed: {
    inspection_types() {
      return inspectionStore.getters['inspection_type/list']
    },
  },
  async created() {
    await this.fetchInspectionTypeList()
  },
  methods: {
    fetchInspectionTypeList() {
      return inspectionStore.dispatch('inspection_type/fetchList')
    },
    goToList(inspection_type) {
      store.commit('inspection/setInspectionType', inspection_type)
      this.$router.push({
        name: 'ManageInspectionMonitor',
      })
    },
    showTypeCreateForm() {
      this.$refs.typeCreateForm.show()
    },
    insertType() {
      // データ再取得
      this.fetchInspectionTypeList()
    },
  },
}
</script>
